module.exports = __webpack_public_path__ + "StagoWeb-x16.b882640e634dc7c42ff1.woff";


//////////////////
// WEBPACK FOOTER
// D:/Ai3/Stago/SAST/Sources/SAST/src/Stago.AAI/ClientAppAngular/src/_stylesheets/fonts/icons/StagoWeb-x16.woff
// module id = ../../../../../src/_stylesheets/fonts/icons/StagoWeb-x16.woff
// module chunks = styles